module.exports = __webpack_public_path__ + "media/claim/assets/images/right_panel/money_200_gbp-6063548cfc9811b055252b9a2201cd33.png";